import {
  GET_SUB_LOT_BY_ID, REFRESH_SUB_LOT_IDS, LOAD_SUB_LOTS, UPDATE_SUB_LOT_STORE,
  PUSH_NEW_EMPTY_SUBLOT, ERASE_SUB_LOTS, ERASE_SUB_LOT_BY_ID, ERASE_OPTIONALS_BY_SUB_LOT,
  REFRESH_OPTIONALS_SUB_LOT_IDS
} from '../types';
import NegotiationSubLotAPI from '../../../API/NegotiationSubLotAPI';
import { RAPPEL_INITIAL_VALUE } from '../../../Utils/Constants';
import store from '../../store';

const newEmptySubLot = {
  0:
  {
    "Id": 0,
    "L1ID": 0,
    "NumA1": "",
    "NumClientRef": "",
    "NumClientRefSchedule": "",
    "NumClientRefScheduleDate": "",
    "ReferenceRentalPrice": "",
    "Quantity": "",
    "RappelDiscountId": RAPPEL_INITIAL_VALUE,
    "RappelDiscountDetail": "",
    "DiscountPercentage": "",
    "DiscountInvoice": "",
    "DiscountOutsideInvoice": "",
    "SMEDiscount": "",
    "BusinessDiscount": "",
    "NoVATInvoiceValue": "",
    "NoVATInvoiceValueString": "",
    "InvoiceDiscountValue": "",
    "InvoiceDiscountValueString": "",
    "PBOptionalsValue": "",
    "PBOptionalsValueString": "",
    "OutOfInvoiceDiscountValue": "",
    "OutOfInvoiceDiscountValueString": "",
    "LPGains": "",
    "AditionalMargin": "",
    "AditionalMarginString": "",
    "LPGainsObservations": "",
    "SubLotCarOptionals": [],
    "ShouldPersist": true
  }
}

export const getSubLotById = (nSubLotId) => dispatch => {

  return new Promise(function (resolve, reject) {

    const oNegotiationSubLotAPI = new NegotiationSubLotAPI();
    oNegotiationSubLotAPI.getSubLotById(nSubLotId).then(response => {
      dispatch({
        type: GET_SUB_LOT_BY_ID,
        payload: { ...response.data, nSubLotId }
      });
      return resolve();

    }).catch((error) => {
      return reject(error);
    });
  });

}

export const updateSubLotStore = (propName, propValue, nSubLotId) => dispatch => {
  return dispatch({
    type: UPDATE_SUB_LOT_STORE,
    payload: { propName, propValue, nSubLotId }
  });
}

export const getMyOwnDataById = (state, nSubLotId) => {
  //should probably invoke the state here instead of passing it so I can reuse this
  return state.negotiationSubLots[nSubLotId];
}

export const pushNewEmptySubLot = () => dispatch => {
  let state = store.getState();
  let aSubLots = state.negotiationSubLots;
  let aSubLotIds = [];

  for (var key in aSubLots) {
    if (aSubLots.hasOwnProperty(key)) {
      aSubLotIds.push(key);
    }
  }
  let maxSubLotId = 0;
  if (aSubLotIds.length > 0)
    maxSubLotId = Math.max(...aSubLotIds);

  maxSubLotId = maxSubLotId + 1;
  let newColdId = maxSubLotId.toString();

  const newEmptySubLot = {
    [newColdId]:
    {
      "Id": 0,
      "L1ID": 0,
      "NumA1": "",
      "NumClientRef": "",
      "NumClientRefSchedule": "",
      "NumClientRefScheduleDate": "",
      "ReferenceRentalPrice": "",
      "Quantity": "",
      "RappelDiscountId": RAPPEL_INITIAL_VALUE,
      "RappelDiscountDetail": "",
      "DiscountPercentage": "",
      "DiscountInvoice": "",
      "DiscountOutsideInvoice": "",
      "SMEDiscount": "",
      "BusinessDiscount": "",
      "NoVATInvoiceValue": "",
      "InvoiceDiscountValue": "",
      "PBOptionalsValue": "",
      "OutOfInvoiceDiscountValue": "",
      "LPGains": "",
      "AditionalMargin": "",
      "LPGainsObservations": "",
      "SubLotCarOptionals": [],
      "ShouldPersist": true
    }
  }

  dispatch({
    type: PUSH_NEW_EMPTY_SUBLOT,
    payload: newEmptySubLot
  });
  return newColdId;
}

export const eraseSubLots = () => dispatch => {

  return dispatch({
    type: ERASE_SUB_LOTS
  });

}

export const eraseSubLotById = (nSubLotId) => dispatch => {
  dispatch({
    type: ERASE_OPTIONALS_BY_SUB_LOT,
    payload: nSubLotId
  });
  return dispatch({
    type: ERASE_SUB_LOT_BY_ID,
    payload: nSubLotId
  });
}

export const refreshSubLotIDs = (oColdToHotSubLotIdMap, lotId) => dispatch => {
  dispatch({
    type: REFRESH_OPTIONALS_SUB_LOT_IDS,
    payload: { ColdToHotSubLotIdMap: oColdToHotSubLotIdMap }
  });
  return dispatch({
    type: REFRESH_SUB_LOT_IDS,
    payload: { ColdToHotSubLotIdMap: oColdToHotSubLotIdMap, lotId }
  });
}

export const loadSubLots = (aSubLotIds) => dispatch => {
  let payload = {};
  if (aSubLotIds.length === 0) {
    return dispatch({
      type: PUSH_NEW_EMPTY_SUBLOT,
      payload: newEmptySubLot
    });
  } else {

    aSubLotIds.forEach(element => {
      let nome = element.toString();

      payload[nome] = {
        "Id": element,
        "L1ID": 0,
        "NumA1": "",
        "NumClientRef": "",
        "NumClientRefSchedule": "",
        "NumClientRefScheduleDate": "",
        "ReferenceRentalPrice": "",
        "Quantity": "",
        "RappelDiscountId": RAPPEL_INITIAL_VALUE,
        "RappelDiscountDetail": "",
        "DiscountPercentage": "",
        "DiscountInvoice": "",
        "DiscountOutsideInvoice": "",
        "SMEDiscount": "",
        "BusinessDiscount": "",
        "NoVATInvoiceValue": "",
        "InvoiceDiscountValue": "",
        "PBOptionalsValue": "",
        "OutOfInvoiceDiscountValue": "",
        "LPGains": "",
        "AditionalMargin": "",
        "LPGainsObservations": "",
        "SubLotCarOptionals": [],
        "ShouldPersist": false
      };

    });
  }

  return dispatch({
    type: LOAD_SUB_LOTS,
    payload: payload
  });

}


// WEBPACK FOOTER //
// ./src/store/actions/NegotiationSubLot/negotiationSubLotActions.js